import '@fontsource/titillium-web';
import { Typography } from "@mui/material";
import HeadbulbLogoSVG from "../../SharedComponents/assets/icons/svg/HeadbulbLogoSVG.js";
import { sellerBottomSidebarLinksData, sellerSidebarLinksData } from "../utils/staticData/sellerSidebarLinks.js";
import { FontEnum } from "../../SharedComponents/utils/enums/FontEnum.js";
import BaseHr from "../../SharedComponents/components/Dividers/BaseHr.js";
import OrderPartLinkDiv from "../../SharedComponents/components/SidebarComponents/OrderPartLinkDiv.js";
import { getUserObject } from "../../../utils/getUserObject.js";
import SidebarFooter from "../../SharedComponents/components/SidebarComponents/SidebarFooter.js";
import { OrderPartVariantDivEnum } from "../../SharedComponents/utils/enums/OrderPartDivVariantEnum.js";
import CircleProgressBar from "./SidebarComponents/CircleProgressBar.js";
import CircledImage from "../../SharedComponents/components/ImageComponents/CircledImage.js";
import SidebarLikeIconSVG from "../assets/icons/svg/SidebarLikeIconSVG.js";
import SidebarDislikeIconSVG from "../assets/icons/svg/SidebarDislikeIconSVG.js";
import { useEffect, useState } from "react";
import api from "../../../api.js";
import { toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';


const SidebarBannerImage = require("../assets/images/sidebar-banner.png");




const SellerSidebar = () => {

    const navigate = useNavigate();

    const [sidebarInfo, setSidebarInfo] = useState({
        positive: 0,
        negative: 0,
        premiumDaysLeft: 0
    });
    const [role, setRole] = useState("");



    useEffect(() => {
        const userRole = getUserObject()?.role;
        setRole(userRole);

        const fetchSellerSidebarInfo = async () => {
            try {
                if (userRole === "seller") {
                    const res = await api.get('/user/sidebar-info/seller');
                    setSidebarInfo({
                        positive: res.data.positive_rated_as_seller,
                        negative: res.data.negative_rated_as_seller,
                        premiumDaysLeft: 0
                    });
                } else if (userRole === "seller_plus") {
                    const res = await api.get('/user/sidebar-info/seller_plus');
                    setSidebarInfo({
                        positive: res.data.user.positive_rated_as_seller,
                        negative: res.data.user.negative_rated_as_seller,
                        premiumDaysLeft: res.data.premium_days_left
                    });
                }
            } catch (err) {
                toast.error("Greška prilikom dohvatanja sidebar informacija");
            }
        };

        fetchSellerSidebarInfo();
    }, []);



    const SidebarHeader = (
        <div style={styles.sidebarHeader}>
            <HeadbulbLogoSVG />
            <Typography style={styles.logoText}>
                SmartPart
            </Typography>
        </div>
    );


    const GetSidebarLinkDiv = (item, index) => {
        const currentPathname = window.location.pathname;
        const isSelected = currentPathname.startsWith(item.href);

        const highlightColor = "rgb(148, 191, 254)";

        const containerStyle = {
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            cursor: 'pointer',
            border: isSelected ? `1px solid ${highlightColor}` : 'none',
            borderRadius: isSelected ? 8 : 0,
            padding: isSelected ? '4px 8px' : 0
        };

        const textStyle = {
            fontFamily: FontEnum.TITILIUM_WEB,
            fontSize: '20px',
            fontWeight: 400,
            color: isSelected ? highlightColor : '#FFFFFF'
        };

        const Icon = <item.icon color={isSelected ? highlightColor : "#FFFFFF"} />;



        return (
            <div
                key={index}
                style={containerStyle}
                onClick={() => navigate(item.href)}
            >
                {Icon}
                <p style={textStyle}>{item.name}</p>
            </div>
        );
    };


    const GetLoggedSellerInfoDiv = () => {
        const profilePicSource = getUserObject()?.small_profile_image_url;

        const style = {
            mainContainer: {
                display: "flex",
                flexDirection: 'column',
                gap: 6,
            },
            likeStatsDiv: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 8
            },
            singleLikeStatDiv: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 2
            },
            likeCountText: {
                fontFamily: FontEnum.TITILIUM_WEB,
                fontWeight: 400,
                fontSize: "16px",
                color: "#FFFFFF"
            },

        };
        const GetName = () => {
            const firstname = getUserObject()?.firstname;
            const lastname = getUserObject()?.lastname;
            return `${firstname} ${lastname}`;
        };

        return (
            <div style={style.mainContainer}>
                <div style={styles.iconContainer}>
                    <CircledImage source={profilePicSource} />

                    <div>
                        <p style={styles.sidebarLinkText}>{GetName()}</p>
                    </div>
                </div>


                <div style={style.likeStatsDiv}>
                    <div style={style.singleLikeStatDiv}>
                        <SidebarLikeIconSVG />
                        <p style={style.likeCountText}>{sidebarInfo.positive}</p>
                    </div>

                    <div style={style.singleLikeStatDiv}>
                        <SidebarDislikeIconSVG />
                        <p style={style.likeCountText}>{sidebarInfo.negative}</p>
                    </div>
                </div>
            </div>
        );
    };



    const GetPremiumLeftDaysDiv = () => {
        return (
            <div style={styles.sidebarLinkMainContainer}>

                <CircleProgressBar days={sidebarInfo.premiumDaysLeft} />

                <p style={styles.sidebarLinkText}>
                    dana premium
                </p>
            </div>
        );


    };


    return (
        <div style={styles.mainContainer}>
            <div style={styles.mainContainerColumn}>

                {SidebarHeader}

                <div style={styles.hrContainer}>
                    <BaseHr />
                </div>

                <OrderPartLinkDiv variant={OrderPartVariantDivEnum.BLUE} />

                {sellerSidebarLinksData.map((item, index) => {
                    return GetSidebarLinkDiv(item, index);
                })}

                <BaseHr />

                <img src={SidebarBannerImage} />

            </div>


            <div style={styles.mainContainerColumn}>
                {sellerBottomSidebarLinksData.map((item, index) => {
                    return GetSidebarLinkDiv(item, index);
                })}

                {role === "seller_plus" && GetPremiumLeftDaysDiv()}

                {GetLoggedSellerInfoDiv()}

                <div style={styles.hrContainer}>
                    <BaseHr />
                </div>

                <SidebarFooter />
            </div>
        </div>
    );
};


export default SellerSidebar;


const styles = {
    mainContainer: {
        display: 'flex',
        flexDirection: 'column',
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        width: 240,
        padding: 20,
        backgroundColor: "black",
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 40,
        overflowY: 'auto',
        height: '100vh',
    },

    mainContainerColumn: {
        display: 'flex',
        flexDirection: 'column',
        width: "100%",
        gap: 10
    },
    hrContainer: {
        marginTop: 20,
        marginBottom: 20
    },
    sidebarLinkMainContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        cursor: 'pointer',
    },
    sidebarLinkText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: '20px',
        fontWeight: 400,
        color: '#FFFFFF'
    },
    sidebarHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 20
    },
    logoText: {
        fontFamily: "Titillium Web",
        color: "#ffffff",
        fontSize: "32px",
        fontWeight: 700
    },
    iconContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 10
    }

};
